import React from 'react'

import TableBodyPrint from './TableBodyPrint'
import TableHeader from './TableHeader.js'
import TableBody from './TableBody.js'
import TableBodyFoldable from './TableBodyFoldable.js'
import './index.css'

const BaseTable = (props) => {
  const { options, data, actions, foldable, order, print, lastRun, checkedRows, setCheckedRows } = props;
    return (
    <div className={`${props.className} table`}>
      <TableHeader
        onSort={props.onSort}
        columns={options.columns}
        padding={props.padding}
        disable={props.disable}
      />
      {foldable ?
        <TableBodyFoldable
          data={data}
          options={options}
          keyProp={props.countingMode === 'Bin' ? 'binName' : props.keyProp}
          padding={props.padding}
          button={props.button}
          order={order}
          countingMode={props.countingMode}
          checkedRows={checkedRows}
          setCheckedRows={setCheckedRows}
        /> : (print ? <TableBodyPrint
            data={data}
            options={options}
            actions={actions}
            onSelectStatus={props.onSelectStatus}
            rowOnClick={props.rowOnClick}
            keyProp={props.keyProp}
            padding={props.padding}
            rowSelectable={props.rowSelectable}
            selectedRow={props.selectedRow}
          /> :
          <TableBody
            data={data}
            options={options}
            actions={actions}
            onSelectStatus={props.onSelectStatus}
            rowOnClick={props.rowOnClick}
            keyProp={props.keyProp}
            padding={props.padding}
            rowSelectable={props.rowSelectable}
            selectedRow={props.selectedRow}
            lastRun={lastRun}
            ordersList={props.ordersList}
          />)

      }
    </div>
  )
}

export default BaseTable
